<div class="row page-header">
    <div class="col-12">
        <h1>Viewpoint Data <small>Vista job cost phase reference (bJCPM phase master, bJCJP job phases for JCCo 1)</small></h1>
    </div>
</div>
<div [hidden]="isInitialLoading">
    <ul ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs">
        <li [ngbNavItem]="1" [destroyOnHide]="false">
            <a ngbNavLink>Phase master (bJCPM)</a>
            <ng-template ngbNavContent>
                <div class="row mt-2">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="phaseMasterGrid"></action-toolbar-count>
                                    <grid-export [grid]="phaseMasterGridRef" [name]="'ViewpointPhaseMaster'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="phaseMasterGrid"
                                    #phaseMasterGridRef
                                    appAutoSize
                                    (initialized)="phaseMasterGrid.initialize(phaseMasterGridRef)"
                                    (destroy)="phaseMasterGrid.destroy()"
                                    [itemsSource]="phaseMasterGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'Phase group'" [binding]="'phaseGroup'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Phase'" [binding]="'phase'" [width]="120"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="260"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Proj min %'"
                                        [binding]="'projMinPct'"
                                        [format]="'n4'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="200"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Key ID'" [binding]="'keyId'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Unique attch ID'" [binding]="'uniqueAttchId'" [width]="260"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'udAlphaCc'" [binding]="'udAlphaCc'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'udShowLaborAnalysis'"
                                        [binding]="'udShowLaborAnalysis'"
                                        [width]="140"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'udPrdept'" [binding]="'udPrdept'" [width]="100"></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
        <li [ngbNavItem]="2" [destroyOnHide]="false">
            <a ngbNavLink>Job phases (bJCJP)</a>
            <ng-template ngbNavContent>
                <div class="row mt-2">
                    <div class="col-lg-12">
                        <div class="row action-toolbar">
                            <div class="col-12">
                                <form class="form-inline">
                                    <action-toolbar-count [grid]="jobPhasesGrid"></action-toolbar-count>
                                    <grid-export [grid]="jobPhasesGridRef" [name]="'ViewpointJobPhases'"></grid-export>
                                </form>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-12">
                                <wj-flex-grid
                                    id="jobPhasesGrid"
                                    #jobPhasesGridRef
                                    appAutoSize
                                    (initialized)="jobPhasesGrid.initialize(jobPhasesGridRef)"
                                    (destroy)="jobPhasesGrid.destroy()"
                                    [itemsSource]="jobPhasesGrid.view"
                                >
                                    <wj-flex-grid-filter></wj-flex-grid-filter>
                                    <wj-flex-grid-column [header]="'JCCo'" [binding]="'jcco'" [width]="70"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Job'" [binding]="'job'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Phase group'" [binding]="'phaseGroup'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Phase'" [binding]="'phase'" [width]="120"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Description'" [binding]="'description'" [width]="260"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Contract'" [binding]="'contract'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Item'" [binding]="'item'" [width]="120"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'Proj min %'"
                                        [binding]="'projMinPct'"
                                        [format]="'n4'"
                                        [width]="100"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Active'" [binding]="'activeYn'" [width]="70"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Notes'" [binding]="'notes'" [width]="200"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Key ID'" [binding]="'keyId'" [width]="100"></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Ins code'" [binding]="'insCode'" [width]="90"></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'udFabJobsHeavyBidNumber'"
                                        [binding]="'udFabJobsHeavyBidNumber'"
                                        [width]="160"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column
                                        [header]="'udPhaseNumeric'"
                                        [binding]="'udPhaseNumeric'"
                                        [format]="'n3'"
                                        [width]="120"
                                    ></wj-flex-grid-column>
                                    <wj-flex-grid-column [header]="'Unique attch ID'" [binding]="'uniqueAttchId'" [width]="260"></wj-flex-grid-column>
                                </wj-flex-grid>
                            </div>
                        </div>
                    </div>
                </div>
            </ng-template>
        </li>
    </ul>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</div>
